import { MutationTree } from 'vuex';
import { UserDataState } from '@/store/types';
import { ICast } from '@/types/cast';
import { IGuest } from '@/types/guest';

const mutations: MutationTree<UserDataState> = {
    setUserData(state, userData: ICast | IGuest) {
        state.userData = userData;
    },
    clearUserData(state){
        state.userData = null;
    }
};

export default mutations;